/* eslint-disable no-console */

// Form submit
// Determines should the user be asked to give marketing consent
// ----------------------------------------------------------------

import $ from 'jquery';

import { validationForm } from './validation-form';

const donationCheckEmailTriggerSelector = '.js-donationCheckEmailTrigger';
const donationFormElement = $('#consolidated-donate-form');
const donationFormSubmitTrigger = 'button[type=submit]';
const donationEmailInput = $('#consolidated-donate-form input[type=email]');
const donationMarketingModal = $('.js-donation-modal');
const donationMarketingModalInputs = $('.js-donation-modal input');
const donationMarketingOutput = $('#donation_marketing');
const donationMarketingModalCloseButton = $('.js-donation-modal .modal-close');
const donationMarketingModalSubmitButton = $('#buttonMarketingSubmitDonationModal');

const marketingNoDonationModal = $('.js-marketingNoDonationModalShowMore');
const marketingNoText = $('.js-donation-marketing-no-text');

let checkedEmail = '';
let initModalOnSubmit = false;
let emailCheckDone = false;

const donationEmailCheck = async () => {
    const hasEmail = $(donationEmailInput).is(':valid');
    const hasDifferentEmail = $(donationEmailInput).val() !== checkedEmail;

    const firstName = $("#donation-first-name").val();

    const text = $('.js-donation-modal-title').text();
    $('.js-donation-modal-title').text(text.replace('%etunimi%', firstName));

    if (hasEmail && hasDifferentEmail) {
        // check email
        emailCheckDone = false;

        const data = {
            email: $(donationEmailInput).val(),
        }
        const options = {
            data: data,
            async: true,
            method: 'POST',
            url: '/wp-json/amnesty-fi/v1/check-email-opt-out',
        };

        $.ajax(options).done((response) => {
            checkedEmail = $(donationEmailInput).val();
            emailCheckDone = true;

            // ----------------------------------------------------------------
            // ----------------------------------------------------------------
            // The original thing before things got updated.
            // if (response && response['userOptOutStatus'] === true) {
            //     $(donationMarketingOutput).val('no');
            //     // we need to init the donation on submit
            //     initModalOnSubmit = true;
            // } else {
            //     $(donationMarketingOutput).val('yes');
            //     // else user has not opted out, no need for modal
            //     initModalOnSubmit = false;
            // }
            // ----------------------------------------------------------------
            // ----------------------------------------------------------------

            if (
              response['userAlreadyExistsStatus'] &&
              response['userAlreadyExistsStatus'] !== 'true'
            ) {
                // $(donationMarketingOutput).val('no');
                initModalOnSubmit = true;
                return;
            }

            if (
              response['userOptOutStatus'] &&
              response['userOptOutStatus'] === 'true'
            ) {
                // $(donationMarketingOutput).val('no');
                initModalOnSubmit = true;
                return;
            }

            else {
              $(donationMarketingOutput).val('yes');
              initModalOnSubmit = false;
            }

            // Submit form after determining the things above.
            // form.off('submit').trigger('submit');

        });

    }
}

marketingNoDonationModal.on('click', function() {
    $(this).parent().find('.js-marketingDonationModalSubmitYes').removeClass('u-bg-yellow')
    $(this).addClass('u-bg-yellow')
    marketingNoText.removeClass('u-hidden');
})

$(donationFormElement).on('click', donationCheckEmailTriggerSelector, donationEmailCheck);

const initDonationMarketingModal = () => {
    // @todo: build a focus trap
    $(donationMarketingModal).addClass('is-open').prop('aria-hidden', false).focus();
    $(donationMarketingModalCloseButton).prop('disabled', false);
    $(donationMarketingModalInputs).prop('disabled', false);
    donationMarketingModalSubmitButton.prop('disabled', false);
}

const closeDonationMarketingModal = () => {
    $(donationMarketingModal).removeClass('is-open').prop('aria-hidden', true);
    $(donationMarketingModalCloseButton).prop('disabled', true);
    $(donationMarketingModalInputs).prop('disabled', true);
    donationMarketingModalSubmitButton.prop('disabled', true);
}

// hijack the form submit event, if needed
const donationMarketingModalSubmitHandler = (buttonClickEvent) => {

    // If all inputs in form are valid then show popup
    var formIsValid = validationForm(donationFormElement);
    if (formIsValid === true) {
        if (initModalOnSubmit && emailCheckDone) {
            buttonClickEvent.preventDefault();
            initDonationMarketingModal();
        }
    }
}

// Block the return button from trying to submit the form, which can become
// problematic when returning to previous steps and return tries to submit
// the form before proper completion.
$(donationFormElement).on('keyup keypress', function(e) {
    var keyCode = e.keyCode || e.which;
    if (keyCode === 13) {
        e.preventDefault();
        return false;
    }
});

$(donationFormElement).on('click', donationFormSubmitTrigger, donationMarketingModalSubmitHandler);


$(donationMarketingModalCloseButton).on('click', () => {
    closeDonationMarketingModal();
});


// const updateFormMarketingData = (marketing = '') => {
//     donationMarketingOutput.val(marketing);
// }

$('.js-marketingDonationModalSubmitYes').on('click', () => {
    // const marketing = 'yes';
    // updateFormMarketingData(marketing);
    $(donationMarketingOutput).prop('checked', true);
    $(donationMarketingOutput).val('yes');
    modalSubmit();
})

$('.js-marketingDonationModalSubmitNo').on('click', () => {
    $('.js-marketingDonationModalSubmitYes').removeClass('u-bg-yellow')
    // const marketing = 'no'
    // updateFormMarketingData(marketing);
    $(donationMarketingOutput).prop('checked', false);
    $(donationMarketingOutput).val('no');
    modalSubmit();
})

const modalSubmit = () => {
    closeDonationMarketingModal();
    $(donationFormElement).off('click', 'button[type=submit]', donationMarketingModalSubmitHandler);
    $(donationFormElement).trigger('submit');
}
